import React, { useEffect, useState } from 'react';

import { Loader, Select, SelectProps, useMantineTheme } from '@mantine/core';
import { SelectItem } from '@mantine/core/lib/Select/types';
import dayjs from 'dayjs';
import usePayrollPeriods from 'hooks/payrollPeriod/usePayrollPeriods';

const PayrollPeriodSelect = (
  props: Omit<SelectProps, 'clearable' | 'data' | 'rightSection'> & { hideOpenPeriods?: boolean },
): JSX.Element => {
  const theme = useMantineTheme();
  const { onChange, onCreate, value, ...selectProps } = props as SelectProps;

  const [options, setOptions] = useState<SelectItem[]>([]);
  const { data, isSuccess, isLoading } = usePayrollPeriods({
    limit: '10000',
  });
  useEffect(() => {
    if (isSuccess && data) {
      const payrollPeriods = data.pages
        .map(page => page.data.results)
        .flat()
        .map(period => ({
          value: period.payrollPeriodId,
          label: `${dayjs(period.startDate).format('MMMM D YYYY')} - ${dayjs(period.endDate).format(
            'MMMM D YYYY',
          )}`,
          startDate: period.startDate,
        }))
        .sort((a, b) => dayjs(b.startDate).valueOf() - dayjs(a.startDate).valueOf());

      setOptions(payrollPeriods);
    }
  }, [data, isSuccess]);

  return (
    <Select
      {...selectProps}
      clearable
      data={options}
      creatable={false}
      onCreate={undefined}
      value={value}
      onChange={nextValue => {
        onChange?.(nextValue);
      }}
      placeholder='Select a payroll period'
      nothingFound='Payroll periods Not Found'
      maxDropdownHeight={100}
      rightSection={isLoading ? <Loader size={theme.fontSizes.md} /> : undefined}
    />
  );
};

export default PayrollPeriodSelect;
